import React, { useState,useEffect } from 'react';
import { Fab, Grid, Typography } from '@material-ui/core';
import { Controller } from 'react-hook-form';

import { makeStyles } from '@material-ui/styles';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import FileIcon from '@material-ui/icons/FileCopy';

import { uploadFile, getFileURL } from '../../../services/storage';
import HSpacer from '../../HSpacer';


const ERROR_MESSAGES = {
  required: 'Campo obligatorio',
  default: '',
};


const useStyles = makeStyles(() => ({
  input: {
    // display: 'none'
  },
  imgUploaded: {
    maxWidth: '98%'
  }
}));

const FormFileUploadField = ({ errors, field, register, rules, setValue, watch, entity, values, control }) => {
  const { name, label } = field
  const errorMessage = errors && errors.type && ERROR_MESSAGES[errors.type];
  const entityURL = entity.toLowerCase();
  const classes = useStyles();
  const [loading, setLoading] = useState(false); // Estado para controlar la carga
  
  useEffect(() => {register({ name }, rules)}, []);

  const handleFileUpload = async (event) => {
    
    const file = event.target.files[0];
    if (file) {
      setLoading(true); // Inicia la carga
      const timestamp = +new Date();
      const filename = `${timestamp}-${file.name}`.replace(/\s/g, '-').replace(/á|à|â|é|è|ê|í|ì|î|ó|ò|ô|ú|ù|û|ç|ñ`/gi,'-');
      const fileLocation = `${entityURL}/${name}/${filename}`;
      const { success } = await uploadFile(file, fileLocation);
      setValue(name, success ? filename : '');
      setLoading(false); // Finaliza la carga
    }
  }

  const handleFileRemove = () => {
    setValue(name, '');
  }

  const value = watch(name, '');
  const fileLocation = getFileURL(`${entityURL}/${name}/${value}`);

  return (
    <Controller
      as={
        <Grid container>
          <Grid item xs={12}>
            <Typography>{label}</Typography>
          </Grid>
          <Grid item xs={12}>
            <div>
              <input 
                className={classes.input}
                id={`${name}-file-upload`}
                type="file"
                onChange={handleFileUpload}
              />
              {/* <label htmlFor={`${name}-file-upload`}>
                <Fab component="span" color="primary">
                  <AddPhotoAlternateIcon />
                </Fab>
              </label> */}
            </div>
          </Grid>
          <HSpacer />
          { loading ? (
            <Grid item xs={12}>
              <Typography>Subiendo el archivo, por favor aguarde...</Typography>
            </Grid>
          ) : (value && (
              <>
                <Grid item xs={6}>
                  <a href={fileLocation} target="_blank" rel="noopener norreferrer" ><FileIcon />{value}</a>
                </Grid>
                <Grid item xs={4}>
                  <Fab component="span" color="secondary" onClick={handleFileRemove}>
                    <DeleteForeverIcon />
                  </Fab>
                </Grid>
              </>
            )
          )
        }           
        </Grid>
      }
      control={control}
      defaultValue={[]}
      error={!!errors}
      fullWidth
      helperText={errorMessage}
      label={label || name}
      labelId={name}
      name={name}
      rules={rules}
      type="text"
      variant="outlined"
    />
  )
}
 
export default FormFileUploadField;